import { IPageSchema } from '../repositories/chats/entities/synchronization/PageSchema';
import {
  fetchGetSubAgentsDesktop,
  TGetSubAgentsDesktopResponse,
} from '../repositories/chats/v1/get-sub-agents-desktop';
import { ERequestApiStatus } from '../types/appState';
import { TContext } from '../types/context';
import { EAgentAccountType, TUser } from '../types/userData';
import { getSubAgentsFetchLimit } from '../utils/getSubAgentsFetchLimit';
import { isSubAgentsChatsEnabled as _isSubAgentsChatsEnabled } from '../utils/isSubAgentsChatsEnabled';

type TFetchSubAgentsParams = {
  parameters?: { offset?: number; search?: string };
  cookies?: string;
  user: TUser;
};

export async function fetchSubAgents(
  { logger, httpApi, config }: TContext,
  { cookies, parameters, user }: TFetchSubAgentsParams,
) {
  const isSubAgentsChatsEnabled = _isSubAgentsChatsEnabled(config);

  if (!user.isAuthenticated || user.agentAccountType !== EAgentAccountType.Agency || !isSubAgentsChatsEnabled) {
    return { status: ERequestApiStatus.Initial, subAgentsList: [], page: {} as IPageSchema };
  }

  const limit = getSubAgentsFetchLimit(config);

  try {
    const { response, statusCode }: TGetSubAgentsDesktopResponse = await fetchGetSubAgentsDesktop({
      httpApi,
      parameters: {
        limit,
        offset: parameters?.offset || 0,
        search: parameters?.search,
      },
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode !== 200) {
      logger.warning('Код ответа не 200', {
        message: 'Не удалось получить список сотрудников',
        domain: 'src/shared/services/fetchSubAgents.ts [fetchSubAgents]',
        statusCode,
        messsage: response.message || 'Неизвестная ошибка',
        errors: JSON.stringify(response?.errors),
      });

      return { status: ERequestApiStatus.Failed, subAgentsList: [], page: {} as IPageSchema };
    }

    return { page: response.page, subAgentsList: response.subAgents, status: ERequestApiStatus.Succeed };
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/fetchSubAgents.ts [fetchSubAgents]',
      message: 'Не удалось получить список сотрудников',
    });

    return { status: ERequestApiStatus.Failed, subAgentsList: [], page: {} as IPageSchema };
  }
}
